import Image from 'next/image';
import Dashboard2FillIcon from 'remixicon-react/Dashboard2FillIcon';
import QuillPenFillIcon from 'remixicon-react/QuillPenFillIcon';
import RestartFillIcon from 'remixicon-react/RestartFillIcon';
import friendInNeed from './friend-in-need.png';
import travelLiability from './travel-liability.png';
import health from './health.png';
import americas from './americas.png';

export const travelCarouselItems = [
  {
    icon: RestartFillIcon,
    heading: 'Its a friend in need',
    text: 'Travel Insurance gives you not only financial security but also a 24/7 available, trustworthy, safety net in an unfamiliar place.',
    rightContent: (
      <div className="hidden place-items-center lg:grid">
        <Image src={friendInNeed} alt="" />
      </div>
    ),
  },
  {
    icon: QuillPenFillIcon,
    heading: 'Personal Liability Coverage',
    text: 'In case of damage to a third party property or person by you, the insurance will cover the expenses, saving you from high expenses.',
    rightContent: (
      <div className="hidden place-items-center lg:grid">
        <Image src={travelLiability} alt="" />
      </div>
    ),
  },
  {
    icon: Dashboard2FillIcon,
    heading: 'Compensations for Health Emergencies',
    text: 'Treatment in a foreign country can weigh heavy on the bank account. Travel insurance policies have tie-ups with local hospitals to ensure that you get the best treatment without breaking the vault.',
    rightContent: (
      <div className="hidden place-items-center lg:grid">
        <Image src={health} alt="" />
      </div>
    ),
  },
];

export const travelfaqList = [
  {
    question: 'Why should I buy travel insurance?',
    answer: `A travel insurance coverage covers medical and non-medical travel-related contingencies such as medical care, baggage loss, trip delay or cancellation, and so on. It provides financial protection against all types of travel-related problems. It assures that you are not stuck in the event of an emergency while travelling.
      <br/>
      Travel insurance is also required in numerous nations when travelling, including the United Kingdom, Austria, Spain, France, Germany, and Belgium. However, whether travelling domestically or internationally, it is suggested that you obtain a travel insurance policy.`,
  },
  {
    question: 'Can the period of travel insurance can be extended?',
    answer:
      'Most travel insurance programmes allow for policy extensions. It is dependent on the insurance that you have chosen, therefore it is best to check with your insurer about the extensions that are available.',
  },
  {
    question: 'Is there any medical check-up required to buy a travel insurance policy?',
    answer:
      'A medical test or checkup is usually not necessary to acquire a travel insurance coverage. However, most insurance companies may require a medical exam before covering senior folks. The insurer may also request medical reports from the insured with a negative medical history. It is also advisable to review particular policy conditions about the requirement of a medical check-up.',
  },
  {
    question: 'Can I get a refund, if I cut short my travel?',
    answer:
      'In case you did not go for travel and you show proof of the same, travel policies usual refund your premium, subject to deductions as applicable. If you cut short your travel, policies may or may not allow premium refund, depending on the conditions specified under the policy terms. It is advisable to read the policy document regarding the refund policy, in case of trip cancellation or curtailment.',
  },
  {
    question: 'What is Loss of Baggage cover?',
    answer:
      'A policy compensates you for the loss of important travel documents, travel funds and personal possessions. The cover may differ from one plan to another.',
  },
];

type TravelGlobeCardProps = {
  name: string;
  places: string[];
  image: StaticImageData;
};
interface StaticImageData {
  src: string;
  height: number;
  width: number;
  blurDataURL?: string;
}
export const countriesData: TravelGlobeCardProps[] = [
  {
    name: 'Americas',
    places: ['Anguilla', 'Argentina', 'Bahamas', 'Chile', 'Belize', 'Curacao', 'Cuba', 'Ecuador', 'Jamaica', 'Panama'],
    image: americas,
  },
  {
    name: 'Europe',
    places: [
      'Belgium',
      'Hungary',
      'Denmark',
      'Italy',
      'Estonia',
      'The Netherlands',
      'Finland',
      'Norway',
      'France',
      'Spain',
      'Germany',
      'Switzerland',
      'Russia',
    ],
    image: americas,
  },
  {
    name: 'Asia',
    places: ['Anguilla', 'Argentina', 'Bahamas', 'Chile', 'Belize', 'Curacao', 'Cuba', 'Ecuador', 'Jamaica', 'Panama'],
    image: americas,
  },
  {
    name: 'Others',
    places: ['Anguilla', 'Argentina', 'Bahamas', 'Chile', 'Belize', 'Curacao', 'Cuba', 'Ecuador', 'Jamaica', 'Panama'],
    image: americas,
  },
];
